import React, { Component, SyntheticEvent, ReactNode  } from 'react'
import Head from 'next/head'
import Markdown from 'react-markdown'
import { connect, DispatchProp } from 'react-redux'
import copy from 'clipboard-copy'
import { Query } from 'react-apollo'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from 'Scss/pages/Product.scss'
import btn from 'Components/Button/Button.scss'
import acc from 'Components/Accordion/Accordion.scss'
import appBar from 'Components/AppBar/AppBar.scss'
import tabs from 'Components/Tabs/Tabs.scss'

import AppBar from 'Components/AppBar'
import Breadcrumb from 'Components/Breadcrumb'
import Button from 'Components/Button'
import Footer from 'Components/Footer'
import Checkbox from 'Components/Checkbox'
import ProductQuantityInput from 'Components/ProductQuantityInput'
import { SVGArrowBack, SVGContact, SVGAddToList, SVGSocialFacebook, SVGSocialEmail, SVGSocialGetlink, SVGLogin, SVGBasketIconBlue, SVGContactActive, SVGIconLink } from 'Components/SVGCollection'
import Accordion from 'Components/Accordion'
import { Tabs } from 'Components/Tabs'
import Gallery from 'Components/Gallery'
import ScrollableProductList from 'Components/ScrollableProductList'
import ProductCard from 'Components/ProductCard'
import { ViewType } from 'Components/ProductQuantityInput/ProductQuantityInput'
import { ViewType as AppBarViewType } from 'Components/AppBar/AppBar'

import { breadcrumbForCategory, getCategoryPath } from 'Utils/helpers/categoryHelper'
import gtmClient, { gtmClientInstance } from 'Utils/gtmClient'
import CartHelper from 'Utils/helpers/cartHelper'
import {toggleCart, cartRequestProductUpdate, refreshShoppingLists} from "Utils/redux/actions";
import { getUnitPrice, getNetPrice, isDiscounted, getCurrentPrice, getBrandAttributeInput, getProductFullURL, StatusMessages, getOriginalPrice, isPersonallyDiscounted, getImageForSizeOrPlaceholder, GROBY_IMAGE_PLACEHOLDER, getProductBrand, getBrandName } from 'Utils/helpers/productAttributeHelper'
import Feedback from 'Components/Modal/components/Feedback'
import CartPanel from 'Components/CartPanel'
import { ProductAllData, products, productsVariables, ProductListData, CartFragment, product, ProductStatus, productPriceSubscribe, productPriceSubscribeVariables, productPriceUnsubscribe, productPriceUnsubscribeVariables, CartFragment_cart_products } from 'Utils/api/gql/types'
import { productsQuery } from 'Utils/api/gql/queries/products'
import uiEventEmitter, { UIEvents } from 'Utils/uiEventEmitter'

import { numberFormatter } from 'Utils/helpers/formatters'
import { showMessage, showDeliveryTypeModal, showErrorModal } from 'Utils/helpers/modalHelper'
import _app from 'Pages/_app'
import { ApolloQueryResult } from 'apollo-boost'
import { StickyContainerFix } from './StickyContainerFix'
import ProductPageShipping from './ProductPageShipping'
import { productPriceSubscribeMutation } from 'Utils/api/gql/mutations/productPriceSubscribe';
import { productPriceUnsubscribeMutation } from 'Utils/api/gql/mutations/productPriceUnsubscribe';
import ProductJsonLd from './ProductJsonLd';
import AddProductToListModal from "Components/Profile/ShoppingList/AddProductToListModal";
import { goToLogin } from 'Utils/helpers/routerHelper';
import ErrorPage from 'Pages/_error';
import PageLink from "./PageLink";
import { brandSlugFromString } from 'Utils/helpers/categoryDetailsHelper';
import { SVGShippingCarDont } from "./SVGCollection";
import { GA4ViewItemList } from './GA4ViewItemList';
import { ITab } from './Tabs/Tabs'

type StateType = {
  sliced: boolean
  isPriceAlertSet: boolean
}

type StatePropType = {
  session: Redux.IStoreSessionData
  productCategories: Array<Webshop.ICategory>
  cart: CartFragment | null
  cartStatus: Redux.ICartStatus
  isOpenedCartPanel: boolean
  productAttributes: Array<Webshop.IProductAttribute>
  deliveryAddress?: Redux.IDeliveryAddress
  checkoutInfo: Redux.IReduxState["checkoutInfo"]
  shoppingLists: Redux.IShoppingListState
}

type OwnPropType = {
  product: ProductAllData
  refetch: () => Promise<ApolloQueryResult<product>>
  originalUrl: string
  analytics?: Redux.PrefixboxAnalyticsInfo
}

type PropType = StatePropType & OwnPropType & DispatchProp

const ProductPageContainer: React.SFC<{ children: ReactNode, isOpenedCartPanel: boolean, product: ProductAllData }> =
  ({ children, isOpenedCartPanel }) =>
    <div className={cn(cg.contentHolder, cl.productPage)}>
      <StickyContainerFix>
        <div className={`${cg.gridContainer} ${cg.panelLayout} ${isOpenedCartPanel === true ? cg.opened : ''}`}>
          {children}
        </div>
      </StickyContainerFix>
    </div>

class ProductPageComponent extends Component<PropType, StateType> {

  constructor(props: PropType) {
    super(props)

    const cartProduct = CartHelper.getInCartItem(props.product.id, props.cart)

    this.state = {
      isPriceAlertSet: props.product.is_subscribed,
      sliced: cartProduct && cartProduct.sliced || false,
    }
  }

  componentDidMount() {
    const { product } = this.props
    const categoryPath = getCategoryPath(String(product.default_category_id), this.props.productCategories);
    gtmClient.sendEvent('productPageView', {
      ecommerce: {
        detail: {
          products: [{
            name: product.name,
            id: product.id,
            price: getCurrentPrice(product),
            brand: getProductBrand(product),
            category: categoryPath.map(c => c.name).join(' / '),
            categoryId: categoryPath.map(c => c.id).join('/')
          }]
        }
      },
      productEAN: product.barcodes && product.barcodes[0],
      price: getCurrentPrice(product),
      productIsPriceReduced: isDiscounted(product),
      productIsOrderable: product.status === ProductStatus.AVAILABLE
    })
    gtmClientInstance.sendViewItem(product);
  }

  componentDidUpdate(prevProps: PropType, prevState: StateType) {
    if (this.state.sliced !== prevState.sliced) {
      const cartItem = CartHelper.getInCartItem(this.props.product.id, this.props.cart)
      if (cartItem) {
        const productInput = CartHelper.convertCartItemToCartInputProduct(cartItem)
        productInput.sliced = this.state.sliced
        this.props.dispatch(cartRequestProductUpdate(productInput))
      }
    }
  }

  refetchShoppingLists = () => {
    this.props.dispatch(refreshShoppingLists())
  }

  setQuantity = async (newQuantity: number, quantityType: Redux.QtyType, additional_info?: string) => {
    this.props.dispatch(cartRequestProductUpdate({
      product: this.props.product,
      newQuantity,
      quantityType,
      additional_info,
      sliced: this.state.sliced
     }))
  }

  addToCart = (e?: SyntheticEvent) => {
    e && e.preventDefault()

    if (!this.props.deliveryAddress) {
      showDeliveryTypeModal(true, () => { this.addToCart() })
      return
    }

    this.props.dispatch(cartRequestProductUpdate({ product: this.props.product, sliced: this.state.sliced }))
  }

  renderProductList (products: Array<ProductListData>, isFetching: boolean) {
    const { isOpenedCartPanel } = this.props

    return (
      <ScrollableProductList isOpenedCartPanel={isOpenedCartPanel} isFetching={isFetching}>
        {products.map((product, i) => (
          <div className={`${cg.cell}`} key={`discountedProducts${product.id}-${i}`}>
            <ProductCard
              product={product} view='grid'
              analytics={{ position: i }}
            />
          </div>
        ))}
      </ScrollableProductList>
    )
  }

  toggleBasketBar = () => {
    this.props.dispatch(toggleCart())
  }

  onSlicedChecked = () => {
    this.setState(state => ({ sliced: !state.sliced }))
  }

  handleFBShare = () => {
    try {
      window.FB.ui({
        method: 'share',
        href: getProductFullURL(this.props.product)
      }, function () { })
    } catch (e) { }
  }

  showLoginModal = (reason: string) => {
    uiEventEmitter.emit(
      UIEvents.SHOW_MODAL_FOR_TIME,
      <Feedback renderIcon={<SVGLogin height={26} width={26}/>}>
        {reason} kérünk,&nbsp;
        <a onClick={() => { uiEventEmitter.emit(UIEvents.CLOSE_MODAL); goToLogin()}}>
          jelentkezz be!
        </a>
      </Feedback>
    )
  }

  handlePriceAlertClick = async () => {
    if (!this.props.session.loggedIn) {
      this.showLoginModal('Az árváltozás-értesítő használatához')
      return
    }
    if (!this.state.isPriceAlertSet) {
      try {
        const result = await _app.apolloClient.mutate<productPriceSubscribe, productPriceSubscribeVariables>({
          mutation: productPriceSubscribeMutation,
          variables: { id: this.props.product.id }
        })
        if (!result.data || !result.data.productPriceSubscribe) {
          throw new Error('No response from backend')
        }
        this.setState({ isPriceAlertSet: true })
      } catch (e) {
        showErrorModal('Hiba történt az árváltozás-értesítés beállítása közben! Kérünk, próbáld újra!')
      }
    } else {
      try {
        const result = await _app.apolloClient.mutate<productPriceUnsubscribe, productPriceUnsubscribeVariables>({
          mutation: productPriceUnsubscribeMutation,
          variables: { id: this.props.product.id }
        })
        if (!result.data || !result.data.productPriceUnsubscribe) {
          throw new Error('No response from backend')
        }
        this.setState({ isPriceAlertSet: false })
      } catch (e) {
        showErrorModal('Hiba történt az árváltozás-értesítés kikapcsolása közben! Kérünk, próbáld újra!')
      }
    }
  }

  handleAddToListClick = async (cartItem: CartFragment_cart_products | null | undefined) => {
    if (!this.props.session.loggedIn) {
      this.showLoginModal('Az bevásárlólisták használatához')
      return
    }
    uiEventEmitter.emit(UIEvents.SHOW_MODAL, <AddProductToListModal productId={this.props.product.id} quantity={cartItem ? cartItem!.piece : this.props.product.default_quantity_minimum || 1} />, this.refetchShoppingLists)
  }

  getMailtoLink = () => {
    return `mailto:?to=&subject=${encodeURI(`[GROBY] ${this.props.product.name}`)}&body=${encodeURI(getProductFullURL(this.props.product))}`
  }

  renderHead() {
    const { product, originalUrl } = this.props
    const title = product.meta_title || `${product.name} Webáruház » ${numberFormatter(getCurrentPrice(product))} Ft - ${product.name} Rendelés, Árak`
    const description = product.meta_description ?
      product.meta_description :
      `${product.name} ${numberFormatter(getCurrentPrice(product))} Ft-tól online rendelhető! ${product.name} Webáruház, árak: már ${numberFormatter(getCurrentPrice(product))} Ft-tól » GRoby On-Line Shop - élelmiszer házhozszállítás, több mint 7000 féle élelmiszer, italáru és vegyiáru termék, raktárról, akár másnap otthonában.`
    const keywords = product.meta_keywords || ''
    const ogImage = getImageForSizeOrPlaceholder(product, 0, 'full')
    return (
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />

        <meta name="og:title" content={product.name} />
        <meta name="og:description" content={product.meta_description || product.description || description} />
        <meta name="og:image" content={ogImage === GROBY_IMAGE_PLACEHOLDER ? `${process.env.GWS_WEB_URL}${GROBY_IMAGE_PLACEHOLDER}` : ogImage} />

        <link rel="canonical" href={`${process.env.GWS_WEB_URL}/termekek/${product.url_key}`} />

      </Head>
    )
  }

  addToCartFactory = (type: Redux.QtyType) => async (e?: SyntheticEvent) => {
    e && e.preventDefault()

    if (!this.props.deliveryAddress) {
      showDeliveryTypeModal(true, () => { this.addToCartFactory(type)() })
      return
    }

    this.props.dispatch(cartRequestProductUpdate({ product: this.props.product, quantityType: type, analytics: this.props.analytics }))
  }

  render() {
    const { product, cartStatus, isOpenedCartPanel } = this.props
    const { sliced } = this.state

    const priceUnit = product.price_unit
    const netPrice = getNetPrice(product)
    const unitPrice = getUnitPrice(product)
    const originalPrice = getOriginalPrice(product)
    const currentPrice = getCurrentPrice(product)
    const breadCrumb = breadcrumbForCategory(String(product.default_category_id), this.props.productCategories)
    const defaultQuantityName = product.default_quantity_name

    const cartItem = CartHelper.getInCartItem(product.id, this.props.cart)
    const brandAttributeInput = getBrandAttributeInput(product)
    const brandName = getBrandName(product)

    const isFetching = CartHelper.isProductFetching(product, cartStatus)
      // TODO: TEMPORARY
    const isProductNotOrderable = false // !product.is_mpl && this.props.deliveryAddress && this.props.deliveryAddress.selected.type === "delivery" && !CheckoutHelper.getMethodStatus("ShippingMethodGRoby", this.props.checkoutInfo.shippingMethods).isAvailable
    const isProductUnavailable = product.status !== ProductStatus.AVAILABLE
    const isAddToCartDisabled = isFetching || isProductUnavailable || isProductNotOrderable

    const handleAddToList = () => {
      this.handleAddToListClick(cartItem)
    }

    return (
      <>
        {this.renderHead()}
        <ProductJsonLd product={product} />
        <AppBar
          viewType={AppBarViewType.SubPage}
          pageTitle={product.name}
          pageType="Product"
          breadcrumb={`Home / Product / ${product.name}`}
        />

        <ProductPageContainer isOpenedCartPanel={isOpenedCartPanel} product={product}>
          <div className={cn(cg.cartOpener, appBar.cartOpener)}>
            <Button
              label="Kosár tartalma"
              className={cn(btn.hollow)}
              disabled={false}
              renderIcon={{ alignIcon: null, ariaLabel: 'ariaLabel', Icon: <SVGArrowBack width={24} height={24} /> }}
              onClick={this.toggleBasketBar}
            />
          </div>
          <CartPanel />
          <div className={cn(cg.contentPanel, cl.productBottom, appBar.contentPanel, cg.mediumOrder1, cg.opened)}>
            <Breadcrumb data={breadCrumb} />

            <div className={cn(cg.gridX, cl.productTop, cg.gridMarginX)}>
              <div className={`${cg.cell} ${isOpenedCartPanel ? cg.medium6 : cg.medium5}`}>
                <Gallery
                  product={product}
                />
              </div>

                <div className={`${cg.cell} ${isOpenedCartPanel ? cg.medium6 : cg.medium7}`}>
                  <h1>{product.name}</h1>
                  {!!currentPrice &&
                   <>
                    <div className={cn(cl.price)}>
                      <div className={cn(cl.currentPrice, { [cl.personalPrice]: isPersonallyDiscounted(product) }, {[cl.hasOldPrice]: !!originalPrice })}>{numberFormatter(currentPrice)} Ft / {defaultQuantityName}</div>

                      {product.webshop_only_price &&
                        <div className={cn(cl.onlyWeb)}>Kizárólag a webshopban érvényes ár!</div>
                      }

                      {isPersonallyDiscounted(product) && <div className={cl.personalPriceInfo}><strong>Egyedi kedvezményes ár</strong></div>}
                      <div className={cn(cl.unitPrice)}><b>Egységár:</b> {numberFormatter(unitPrice)} Ft / {priceUnit}</div>
                      <div className={cn(cl.netPrice)}><b>Nettó eladási ár:</b> {numberFormatter(netPrice)} Ft / {defaultQuantityName} ({product.vat}% áfa)</div>

                      {product.empties && (
                        <div className={cn(cl.empties)}><span className={cn(cl.emptiesKey)}>Visszaváltási díj:</span> <span className={cn(cl.emptiesValue)}>{numberFormatter(product.empties.price)}&nbsp;Ft{!!defaultQuantityName && <>&nbsp;/&nbsp;{defaultQuantityName}</>}</span></div>
                      )}
                      {isProductNotOrderable && !isProductUnavailable && (
                        <div className={cg.gridX} style={{ marginTop: "25px" }}>
                          <div className={cn(cg.cell, cg.shrink)}>
                            <SVGShippingCarDont width={36} height={36} />
                          </div>
                          <div className={cn(cg.cell, cg.auto)}>
                            <div className={cl.noDeliveryInfo}>
                            A termék csak Budapesten és környékén érhető el. <br />
                            <strong>Megrendeléshez <a onClick={() => showDeliveryTypeModal(false)}>válts átvételi módot vagy helyet!</a></strong>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                  <div className={cn(cl.price)}>
                    { product.sliceable &&
                        <Checkbox label={'Szeletelve kérem'} checked={sliced} name={'sliced'} error={null} onChange={this.onSlicedChecked} />
                    }
                  </div>
                  <div className={cn(cl.toCart)}>
                  {cartItem
                    ? (
                      <ProductQuantityInput
                        view={ViewType.ProductPage}
                        cartItem={cartItem}
                        onChange={this.setQuantity}
                      />
                    )
                    : (
                      <>
                        <Button
                          style={{marginTop: '30px', marginBottom: '30px'}}
                          label="Kosárba"
                          className={cn(cl.button, btn.largeWidth)}
                          renderIcon={{
                            ariaLabel: 'Kosárba',
                            Icon: <SVGBasketIconBlue width="24" height="24" aria-hidden="true" />,
                          }}
                          disabled={isAddToCartDisabled}
                          onClick={this.addToCart}
                        />
                        <div className={cn(cg.textCenter, cg.largeTextLeft)}>
                          <div className={`${cl.productQuantityInfo}`}>
                            {product.alternative_quantity_name && !isProductUnavailable && `1 ${product.alternative_quantity_name} = ${product.alternative_quantity_exchange_rate} ${product.default_quantity_name}`}
                          </div>
                          {product.alternative_quantity_name && !isProductUnavailable &&
                            <Button
                              label={`+1 ${product.alternative_quantity_name} a kosárba`}
                              className={cn(btn.button, btn.blank, cl.cardboardLink)}
                              onClick={this.addToCartFactory('alternative')}
                            />
                          }
                        </div>
                      </>
                    )
                  }
                  </div>
                  </>}
                  {isProductUnavailable && <p className={cl.unavailableInfo}>{StatusMessages[product.status]}</p>}
                <div className={cn(cg.gridX, cl.addOn)}>
                  <div className={cn(cg.cell, cg.small6, cg.largeShrink)}>
                    <a onClick={handleAddToList}>
                      <span className={cn(cl.addOnLink)}>
                      <SVGAddToList width={32} height={32} />{/*TODO: <SVGAddedToList width={32} height={32} />*/}
                        Bevásárlólistához adom
                      </span>
                    </a>
                  </div>
                  <div className={cn(cg.cell, cg.small6, cg.largeShrink)}>
                    <a onClick={this.handlePriceAlertClick}>
                      <span className={cn(cl.addOnLink)}>
                        {!this.state.isPriceAlertSet
                          ? <><SVGContact width={32} height={32} />Értesíts, ha olcsóbb!</>
                          : <><SVGContactActive width={32} height={32} />Nem kérek értesítést</>}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={cn(cl.productDetails)}>
                <Accordion
                  ariaId="description"
                  ariaLevel={2}
                  defaultOpened={true}
                  className={cn(cl.noBorder)}
                  renderHeader={<h2>Termékleírás a(z) {product.name} termékhez:</h2>}
                >
                  <div className={cn(acc.accordionText)}>
                    <Markdown source={(product.description || '')} />
                    {!!product.min_expiry_days && <p>Minimum szavatosság: {product.min_expiry_days} nap</p>}
                  </div>
                </Accordion>
                <hr />

                {(product.components && product.components.length > 6) &&
                  <>
                    <Accordion
                      ariaId="ingredients"
                      ariaLevel={2}
                      className={cn(cl.noBorder)}
                      renderHeader={<h2>A(z) {product.name} termék összetevői:</h2>}
                    >
                      <div className={cn(acc.accordionText)}><Markdown source={product.components} /></div>
                    </Accordion>
                    <hr />
                  </>
                }
                {(product.nutrition_data && product.nutrition_data.length > 4) &&
                  <>
                    <Accordion
                      ariaId="nutritionData"
                      ariaLevel={2}
                      className={cn(cl.noBorder)}
                      renderHeader={<h2>A(z) {product.name} termék tápanyagai:</h2>}
                    >
                      <div className={cn(acc.accordionText)}>
                        <Markdown source={product.nutrition_data} />
                      </div>
                    </Accordion>
                    <hr />
                  </>
                }

              </div>
              <div className={cn(cg.gridX, cg.pageSection)}>
                <ProductPageShipping isMpl={product.is_mpl} />
                <div className={cn(cg.cell, cg.large5)}>
                  <div className={cn(cl.shareAndRating)}>
                    <div className={cn(cg.gridX)}>
                      <div className={cn(cg.cell, cg.small6)}>
                        <strong>Megosztás</strong>
                      </div>
                      <div className={cn(cg.cell, cg.small6, cg.textRight, cl.socialIcons)}>
                        <a href="#" title="Megosztás facebookon" onClick={this.handleFBShare}>
                          <SVGSocialFacebook width={32} height={32} style={{color: '#3b5998'}} />
                        </a>
                        <a href={this.getMailtoLink()} title="megosztás emailen">
                          <SVGSocialEmail width={32} height={32} />
                        </a>
                        <a title="Link másolása" onClick={e => { e.preventDefault(); copy(getProductFullURL(this.props.product)).then(() => { showMessage('A linket a vágólapra másoltuk!') }); }}>
                          <SVGSocialGetlink width={32} height={32} />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className={cn(cg.gridX, cg.pageSection)}>
                <div className={cn(cg.cell, cg.large8)}>
                  <div className={cn(cg.youtube)}>
                    <iframe width="100%" height="auto" src="https://www.youtube.com/embed/fBiN52X7AmU" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                  </div>
                </div>
                <div className={cn(cg.cell, cg.large4)}>
                  <div className={cn(cg.gridX)}>
                    <div className={cn(cg.cell, cg.medium6, cg.large12, cl.productPageBanner)}>
                      <img src="/static/demo/fake-banner.png" />
                    </div>
                    <div className={cn(cg.cell, cg.medium6, cg.large12, cl.productPageBanner)}>
                      <img src="/static/demo/fake-banner.png" />
                    </div>
                  </div>
                </div>
              </div> */}
              <div className={cn(cg.pageSection, cl.tabSection)}>
              <Query<products, productsVariables>
                query={productsQuery}
                skip={!brandAttributeInput}
                variables={{
                  filters: {
                    attributes: brandAttributeInput ? [brandAttributeInput] : undefined
                  },
                  page: 1,
                  count: 10,
                  pageURL: _app.getCurrentPath()
                }}
                fetchPolicy="network-only"
              >
              {brandResult => {
                      const bottomSectionTabs: ITab[] = []
                      if (brandAttributeInput && brandResult.data && brandResult.data.products && brandResult.data.products.products && brandResult.data.products.products.length > 0) {
                        const brandProducts = brandResult.data.products.products
                          .filter(product => product.id !== this.props.product.id)

                        bottomSectionTabs.push({
                          label: 'A márka további termékei',
                          render:
                            <div className={cn(cg.pageSection)}>
                              {brandName &&
                                <div className={cn(cg.textRight)}>
                                  <PageLink toPage={`/brands/${brandSlugFromString(brandName)}`} className={cn(cl.pageLink)}>
                                    Az összes {brandName} termék
                                    <SVGIconLink width={18} height={18} />
                                  </PageLink>
                                </div>}
                              <GA4ViewItemList products={brandProducts} loading={brandResult.loading} ga4Info={{listId: "brand-products", listName: "Brand Products"}} />
                              { this.renderProductList(brandProducts, brandResult.loading) }
                            </div>
                        })
                      }

                      if (bottomSectionTabs.length > 0) {
                        return <Tabs className={cn(tabs.productTabs)} tabs={bottomSectionTabs} />
                      } else {
                        return null
                      }
                    }}
              </Query>
            </div>
          </div>
          </ProductPageContainer>
        <Footer />
      </>
    )
  }
}

function mapToStateProps({ session, productCategories, cart, cartStatus, deliveryAddress, scheduledData, isOpenedCartPanel, shoppingLists, checkoutInfo }: Redux.IReduxState) {
  return {
    session,
    productCategories,
    cart,
    cartStatus,
    deliveryAddress,
    isOpenedCartPanel,
    shoppingLists,
    checkoutInfo,
    productAttributes: scheduledData.productAttributes
  }
}

export default connect(mapToStateProps)(ProductPageComponent)
